export { TextWithTimer } from './components/TextWithTimer'